import {
  FilePurpose,
  isAllowedImageType,
  useUploadMedia,
} from '@platform/media';

import { mediaApi } from '@/shared/api/media.api';

/**
 * 품셈 본문 도해 업로드.
 *
 * purpose 는 `PUMSEM_MEDIA` — 이미지 전용이고 ADMIN 전용이다. 도움말의
 * `DOCS_MEDIA` 를 재사용하지 않은 이유는 **S3 prefix** 다: purpose 가 곧 보관
 * 위치(`pumsem/media/`)라, 재사용하면 품셈 도해가 `docs/media/` 아래 섞이고
 * prefix 는 한번 정하면 못 바꾼다.
 *
 * 결과는 **절대 CDN URL** 이라 `pumsemImageUrl` 이 그대로 통과시킨다
 * (상대 키에만 `pumsem/` 을 붙인다).
 */
export function usePumsemImageUpload() {
  return useUploadMedia({
    getPresignedUrl: mediaApi.getPresignedUrl,
    confirmUpload: mediaApi.confirmUpload,
    defaultPurpose: FilePurpose.PUMSEM_MEDIA,
    validateType: isAllowedImageType,
  });
}
